import type { ReactNode } from "react";

import LogoIcon from "metabase/common/components/LogoIcon";
import { useSelector } from "metabase/lib/redux";
import { getLoginPageIllustration } from "metabase/selectors/whitelabel";
import egaPic from "./assets/images/ega_pic.png";


import {
  LayoutBody,
  LayoutCard,
  LayoutIllustration,
  LayoutRoot,
} from "./AuthLayout.styled";
import ImageSliderComponent from "./components/right_side_component";
import { RadialGrowBackGround } from "metabase/landing_page/components/mid-section/radial-grow-back-ground";


interface AuthLayoutProps {
  children?: ReactNode;
}

export const AuthLayout = ({ children }: AuthLayoutProps): JSX.Element => {
  const loginPageIllustration = useSelector(getLoginPageIllustration);

  return (
    <LayoutRoot data-testid="login-page">
      <div style={{
        flex: 1,
        background: "linear-gradient(180deg, #e3f2fd 0%, #f0f7fc 40%, #ffffff 100%)",
        position: "relative",
        zIndex: 1
      }}>
        <button
          onClick={() => (window.location.href = "/")} // Go to home page
          style={{
            position: "absolute",
            top: "16px",
            left: "16px",
            padding: "8px 14px",
            borderRadius: "12px",
            backgroundColor: "#2C577D",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            zIndex: 3, // on top of image and dots
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            fontWeight: 500
          }}
        >
          ← Home
        </button>
        <RadialGrowBackGround
          animeDelay={`${Math.random() * 1}s`}
          animeDuration={`${3 + Math.random() * 10}s`}
          topPosition={`${10 + Math.random() * 10}%`}
          leftPosition={`${30 + Math.random() * 20}%`}
        />
        <RadialGrowBackGround
          animeDelay={`${Math.random() * 4}s`}
          animeDuration={`${3 + Math.random() * 6}s`}
          topPosition={`${30 + Math.random() * 20}%`}
          leftPosition={`${20 + Math.random() * 50}%`}
        />
        <RadialGrowBackGround
          animeDelay={`${Math.random() * 2}s`}
          animeDuration={`${3 + Math.random() * 20}s`}
          topPosition={`${30 + Math.random() * 50}%`}
          leftPosition={`${20 + Math.random() * 5}%`}
        />
        <LayoutBody>
          <img src={egaPic} alt="eGA Logo" height={95} />
          <LayoutCard>{children}</LayoutCard>
        </LayoutBody>
      </div>
      <div style={{ backgroundColor: "red", flex: 1 }}>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", width: "100%" }}>
          <ImageSliderComponent />
        </div>
      </div>
    </LayoutRoot>
  );
};
